import environment from "environment";
import { Connect } from "./connect";
import { IOverduePatrimonialRightsPayload } from "./types";

/**
 * Servicio para descargar derechos patrimoniales de pagos ordinarios
 */
export class PatrimonialRightsConnect extends Connect {
  constructor() {
    const { apiKey, apiMsIntegration } = environment;
    const login = { idToken: sessionStorage.getItem("idToken") };
    super(apiMsIntegration, "", {
      apiKey,
      token: login.idToken ? login.idToken : ""
    });
  }

  /**
   * Obtiene el reporte de derechos patrimoniales para pagos ordinarios
   * GET /api/v2/payments/:campaignId/patrimonial-rights
   */
  async getPatrimonialRightsReport(
    payload: IOverduePatrimonialRightsPayload
  ): Promise<any> {
    const params: Record<string, any> = {};

    if (payload.userId) {
      params.userId = payload.userId;
    }
    if (payload.userEmail) {
      params.userEmail = payload.userEmail;
    }
    if (payload.issuerPaymentID) {
      params.issuerPaymentID = payload.issuerPaymentID;
    }

    const response = await this.request({
      method: "get",
      service: `acc-integration/api/v2/payments/${payload.campaignId}/patrimonial-rights`,
      params,
      headers: {
        "x-api-key": environment.apiKey
      }
    });
    return Promise.resolve(response?.data);
  }
}
